import { render, staticRenderFns } from "./MessageHeader.vue?vue&type=template&id=895ff70c&scoped=true"
import script from "./MessageHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MessageHeader.vue?vue&type=style&index=0&id=895ff70c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895ff70c",
  null
  
)

export default component.exports